import { Outlet } from "react-router-dom";

export const Invoicings = (): JSX.Element => {
  return <Outlet />;
};
